const config = JSON.parse(
  document.getElementById('js-bundle-runtime-config').innerHTML,
);

config.styleName = (config.STYLE_NAME || 'aurus').toLowerCase();

const workMode = (config.WORK_MODE || 'aurus').toLowerCase();

config.workMode = {
  isModeAurus: workMode === 'aurus',
  isModeSollers: workMode === 'sollers',
  isModeArgo: workMode === 'uaz',
};

export default config;
